import { render, staticRenderFns } from "./remitConfirm.vue?vue&type=template&id=1bf67a42&scoped=true&"
import script from "./remitConfirm.vue?vue&type=script&lang=js&"
export * from "./remitConfirm.vue?vue&type=script&lang=js&"
import style0 from "./remitConfirm.vue?vue&type=style&index=0&id=1bf67a42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf67a42",
  null
  
)

export default component.exports